import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { UserCircle } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { Card, CardContent } from '../ui/card';
import { ChangePasswordCard } from './ChangePasswordCard';

const API = process.env.REACT_APP_BACKEND_URL;
export const fmtWhen = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' }) : 'Never');

const Row = ({ label, value, testId }) => (
  <div className="flex justify-between gap-4 py-2 border-b border-neutral-100 last:border-0 text-sm">
    <span className="text-neutral-500">{label}</span>
    <span className="font-medium text-right" data-testid={testId}>{value}</span>
  </div>
);

// Admin → My Account: who I am, last login / password change, and Change Password.
export default function MyAccountTab() {
  const { user, token, updateToken } = useAuth();
  const [sec, setSec] = useState(null);
  const load = useCallback(() => {
    axios.get(`${API}/api/auth/my-security`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => setSec(r.data)).catch(() => {});
  }, [token]);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-6 max-w-3xl" data-testid="my-account-tab">
      <div>
        <h2 className="text-2xl font-serif flex items-center gap-2"><UserCircle className="h-6 w-6 text-amber-600" /> My Account</h2>
        <p className="text-sm text-neutral-500 mt-1">Your sign-in details and password.</p>
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        <Card><CardContent className="pt-6">
          <Row label="Name" value={user?.name || '—'} testId="my-account-name" />
          <Row label="Email" value={user?.email || '—'} testId="my-account-email" />
          <Row label="Role" value={(user?.role_id || (user?.is_admin ? 'admin' : 'user')).replace('role_', '').replace(/_/g, ' ')} testId="my-account-role" />
          <Row label="Last login" value={fmtWhen(sec?.last_login_at)} testId="my-account-last-login" />
          <Row label="Last password change" value={sec?.password_changed_at ? fmtWhen(sec.password_changed_at) : 'Not changed yet'} testId="my-account-last-password-change" />
        </CardContent></Card>
        <Card><CardContent className="pt-6">
          {/* No onChanged reload here: `load` closes over the now-revoked token (401 -> global logout); the token change re-runs load. */}
          <ChangePasswordCard token={token} onNewToken={updateToken} />
        </CardContent></Card>
      </div>
    </div>
  );
}
